export const ALL_DUMMY_DOCUMENTS = [
  {
    id: '1',
    name: 'Franchise Agreement',
    url: 'https://example.com/franchise-agreement.pdf',
    size: 2500000,
  },
  {
    id: '2',
    name: 'Financial Statement',
    url: 'https://example.com/financial-statement.xlsx',
    size: 1200000,
  },
  {
    id: '3',
    name: 'Operations Manual',
    url: 'https://example.com/operations-manual.docx',
    size: 3800000,
  },
];

export const UPLOADED_DUMMY_DOCUMENTS = [
  {
    id: '1',
    name: 'Business Plan',
    url: 'https://example.com/business-plan-2024.pdf',
    size: 1800000,
  },
  {
    id: '2',
    name: 'Location Photos',
    url: 'https://example.com/store-photos.docx',
    size: 5200000,
  },
  {
    id: '3',
    name: 'Sales Projections',
    url: 'https://example.com/sales-forecast.xlsx',
    size: 950000,
  },
];

export const SIGNED_DUMMY_DOCUMENTS = [
  {
    id: '1',
    name: 'Franchise Agreement',
    url: 'https://app.docusign.com/documents/123456',
    size: 2500000,
    stage_name: 'Legal Review',
    checklist: 'Terms & Conditions, Payment Schedule',
    signedAt: new Date('2024-03-15T10:30:00'),
  },
  {
    id: '2',
    name: 'Location Survey Form',
    url: 'https://form.jotform.com/240123456789',
    size: 1200000,
    stage_name: 'Site Survey',
    checklist: 'Location Photos, Area Measurements',
    signedAt: new Date('2024-03-14T15:45:00'),
  },
  {
    id: '3',
    name: 'Financial Assessment',
    url: 'https://app.pandadoc.com/document/789012',
    size: 3800000,
    stage_name: 'Financial Review',
    checklist: 'Credit Check, Bank Statements',
    signedAt: new Date('2024-03-13T09:15:00'),
  },
];
